<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-select v-model="keywordType" placeholder="请选择" style="width: 120px;margin-right: 10px;" size="small">
          <el-option label="合同号" :value="1"></el-option>
        </el-select>
        <el-input v-model="keyword" placeholder="请输入内容" style="width: 300px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <el-date-picker v-model="today" type="month" placeholder="选择月" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="客户" min-width="100" prop="xuhao"></el-table-column>
          <el-table-column align="center" label="合同号" min-width="100" prop="dingdanhao"></el-table-column>
          <el-table-column align="center" label="货号" min-width="100" prop="xinghao"></el-table-column>
          <el-table-column align="center" label="产品规格" min-width="100" prop="gongxu"></el-table-column>
          <el-table-column align="center" label="合同数量" min-width="100" prop="dingdanliang"></el-table-column>
          <el-table-column align="center" label="组焊件名称" min-width="100" prop="liaohao"></el-table-column>
          <el-table-column align="center" label="套用量" min-width="100" prop="taoyongliang"></el-table-column>
          <el-table-column align="center" label="组焊件标准量" min-width="100" prop="biaozhunliang"></el-table-column>
          <el-table-column align="center" label="单价" min-width="100" prop="danjia"></el-table-column>
          <el-table-column align="center" label="焊道长度" min-width="100" prop="handao"></el-table-column>
          <el-table-column align="center" label="期初库存" min-width="100" prop="qichukucun"></el-table-column>
          <el-table-column align="center" label="期初产量" min-width="100" prop="qichuchanliang"></el-table-column>
          <el-table-column align="center" label="期初金额" min-width="100" prop="qichujine"></el-table-column>
          <el-table-column align="center" label="当日库存" min-width="150" prop="kucun"></el-table-column>
          <el-table-column align="center" label="当日产量" min-width="100" prop="wanchengliang"></el-table-column>
          <el-table-column align="center" label="订单欠量" min-width="100" prop="dingdanqianliang"></el-table-column>
          <el-table-column align="center" label="本月库存" min-width="100" prop="benyuekucun"></el-table-column>
          <el-table-column align="center" label="本月产量" min-width="100" prop="benyuechanliang"></el-table-column>
          <el-table-column align="center" label="本月金额" min-width="150" prop="benyuejine"></el-table-column>
          <el-table-column align="center" label="累计库存" min-width="100" prop="leijikucun"></el-table-column>
          <el-table-column align="center" label="累计产量" min-width="100" prop="leijichanliang"></el-table-column>
          <el-table-column align="center" label="累计金额" min-width="100" prop="leijijine"></el-table-column>
          
        </el-table>
        <!-- <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>

    
  </div>
</template>

<script>
  import axios from 'axios';
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      today: '',
      sf: '',
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      axios.post(this.$host+'/index.php/admin/Orderexcel/hanjieExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '焊接车间日报表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        // page: this.pageNum,
        // num: this.pageSize,
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      this.$request.post('/index.php/admin/index/hanjieBiao', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
